import { render, staticRenderFns } from "./FIBStaffButton.vue?vue&type=template&id=4e25fd75&"
import script from "./FIBStaffButton.vue?vue&type=script&lang=js&"
export * from "./FIBStaffButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports